export default __webpack_public_path__ + "static/media/Smoothening.9a81f4a1.jpg";